import { gql } from '__generated__';

export default gql(`
  mutation DeleteScanner($id: ID!) {
    deleteScanner(id: $id)
  }
`);
